// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"030b0825","360":"475aab44"}[chunkId] + ".chunk.js";
};